export default "__VITE_ASSET__CQxH4n7V__"